import {Component, OnInit} from '@angular/core';
import {GenericDataViewService} from "../generic-data-view.service";
import {IonicPage, NavParams} from "ionic-angular";
import {DetailsConfig} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/interfaces/details-config.interface";
import {MapOfStringTo} from "../../modules/ranking/interfaces/utils";
import {ProcessService} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service";
import {
  FormDefinition
} from "../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-definition.interface";
import {HttpClient} from "@angular/common/http";

@IonicPage()
@Component({
  selector: 'generic-data-view-details',
  templateUrl: './generic-data-view-details.page.html',
})
export class GenericDataViewDetailsPage implements OnInit {
  public config: DetailsConfig;
  public baseUrl: string;
  public db: any;
  public loading: boolean = false;
  public detailsData: MapOfStringTo<any>; // data to evaluate values in details component

  constructor(private genericDataViewService: GenericDataViewService,
              private navParams: NavParams,
              private processService: ProcessService,
              private http: HttpClient) {}

  ngOnInit() {
    const data = this.navParams.data;
    this.config = this.genericDataViewService.getConfig(data.viewId);
    this.baseUrl = this.genericDataViewService.getBaseUrl(this.config);
    this.detailsData = data.element;
  }
  editDetails(processKey: string) {
    this.processService
      .getProcessWithForm(this.baseUrl, processKey)
      .subscribe((formDefinition: FormDefinition) => {
        const fields = formDefinition.form
        const formName = formDefinition.formName
        this.processService
          .initProcess(this.baseUrl, {formJson: fields, formName, key: processKey, data: this.detailsData})
          .subscribe(() => {
            this.loading = true;
            setTimeout(() => {
              this.http.get(this.baseUrl + this.config.dataSourceConfig.onlineDataSourceUrl + '/' + this.detailsData.id)
                .subscribe(data => {
                  this.detailsData = data;
                  this.loading = false;
                });
            }, 3000);
          });
      });
  }

  onButtonClick(event) {
    this.editDetails(event.processKey);
  }
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-details/generic-data-view-details.page.ts